import React, { useMemo } from "react";
import { Carousel } from "antd";
import styles from "./similarAdsCarousel.scss";
import Paging from "./Paging";
import { SimilarAdCard } from "../../../../../components/SimilarAdCard";
import ReactGA from "react-ga4";
import useHrPageName from "../../../../../utils/useHrPageName";

const similarAdsCarouselClassName = "similarAdsCarousel";

const SimilarAdsCarousel = ({ similarAds, category, hasFavorite, noBackground }) => {
  const hrPageName = useHrPageName(category)

  const sendGoogleEvent = () => {
    ReactGA.event({
      category: "Detalji oglasa",
      action: "Click",
      label: `Odabir sličnih oglasa - ${hrPageName}`
    });
  };

  const focusAd = () => {
    const item = document.querySelectorAll(`.${similarAdsCarouselClassName} > div > div > .slick-current > div`);
    if (item && item.length > 0) {
      // @ts-ignore
      item[0].focus({ preventScroll: true });
      // @ts-ignore
      item[0].click();
    }
    const a = document.querySelectorAll(`.${similarAdsCarouselClassName} > div > div > .slick-current > div > a`);
    if (a && a.length > 0) {
      // @ts-ignore
      a[0].focus({ preventScroll: true });
    }
  };

  const slides = useMemo(() => similarAds.map((ad: any) => (
    <div key={ad.id} className={`${styles.slide} ${similarAds.length === 1 ? styles.slideOnly : ""}`}>
      <SimilarAdCard
        ad={ad}
        category={category}
        onClick={sendGoogleEvent}
        hasFavorite={hasFavorite !== undefined ? hasFavorite : true}
        eventLabel={`Similar Ads - Gallery swipe`}
      />
    </div>
  )), [similarAds, category, sendGoogleEvent]);

  return (
    <Carousel
      className={`${styles.carousel} ${similarAdsCarouselClassName}`}
      slidesToShow={1}
      slidesToScroll={1}
      // @ts-ignore
      customPaging={Paging}
      infinite={true}
      draggable={false}
      touchThreshold={5}
      waitForAnimate={false}
      centerMode={true}
      style={noBackground ? { background: "none" } : {}}
      afterChange={focusAd}
    >
      {slides}
    </Carousel>
  );
};

export default SimilarAdsCarousel;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/SimilarAdsSection/SimilarAdsCarousel/index.tsx